import { LogisticAddress } from './address.model';

export class ShipTo {
  labCode: string;
  company: string;
  contactName: string;
  phone: string;
  address: LogisticAddress;
}
